var _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFiremapMachine = function SvgFiremapMachine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9,
    stroke: "#21272C",
    strokeWidth: 2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#firemap-machine_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#21272C",
    d: "M13.219 10.375a.409.409 0 0 0-.069-.226l-1.142-1.713a2.029 2.029 0 0 0-1.69-.905h-2.38a.406.406 0 0 0-.407.407v4.468h5.688zm-3.25 0V8.344h.349c.408 0 .787.203 1.014.543l.992 1.488z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M17.688 15.656a1.22 1.22 0 0 1-1.22-1.219v-2.03a.406.406 0 1 0-.812 0v1.624h-1.038a1.62 1.62 0 0 0-1.4-.812H7.532c-.896 0-1.625.729-1.625 1.625s.73 1.625 1.625 1.625h5.688c.755 0 1.386-.52 1.567-1.219h1.043a2.032 2.032 0 0 0 1.858 1.219.406.406 0 1 0 0-.813m-9.75 0a.813.813 0 1 1 .001-1.626.813.813 0 0 1-.002 1.626m2.437 0a.813.813 0 1 1 .002-1.626.813.813 0 0 1-.002 1.626m2.438 0a.813.813 0 1 1 .001-1.626.813.813 0 0 1-.002 1.626"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "firemap-machine_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M5.5 5.5h13v13h-13z"
  })))));
};
export default SvgFiremapMachine;